import { render } from "./inventoryDetail.vue?vue&type=template&id=c46f22ca&scoped=true"
import script from "./inventoryDetail.vue?vue&type=script&lang=js"
export * from "./inventoryDetail.vue?vue&type=script&lang=js"

import "./inventoryDetail.vue?vue&type=style&index=0&id=c46f22ca&scoped=true&lang=scss"

import exportComponent from "/var/jenkins_home/workspace/edu-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c46f22ca"]])

export default __exports__